function findDuration(duration) {
  if (typeof duration === 'number') return duration

  const cssValue = getComputedStyle(document.documentElement).getPropertyValue(`--${ duration }-animation-duration`)
  return parseInt(cssValue, 10)
}

export async function animateCollapse(element, from, to, duration = 'normal') {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  element.style.overflow = 'hidden'

  element.animate([
    { height: `${ from }px` },
    { height: `${ to }px`, easing: 'ease-out' }
  ], findDuration(duration))

  await Promise.allSettled(element.getAnimations().map(v => v.finished))

  element.style.overflow = ''
}
